import { List } from "@mui/material"
import { observer } from "mobx-react-lite"
import { useContentEditorStore } from "pages/content/store"
import { scrollbarStyle } from "styles/global-styles"
import BaseBlock from "../blocks/base"

const ContentFields = observer(() => {

  const contentStore = useContentEditorStore()

  return (
    <List disablePadding sx={{ overflow: "auto", pr: 1, pb: 2,  ...scrollbarStyle }}>
      { contentStore.contentBlocks.map((item, index) => (
        <BaseBlock state={item} key={index} value={contentStore.values[index]} />
      ))}
    </List>
  )
})

export default ContentFields